import React from 'react'

import { Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { ArrayField, useTranslate } from 'react-admin'

import { normalGray, darkGray } from '../../constants/colorConstants'
import { CurrencyField } from '../fields/currencyField'
import { LocalDateField } from '../fields/localDateField'
import { PaymentDescriptionField } from '../fields/paymentDescriptionField'
import { PaymentPayerField } from '../fields/paymentPayerField'
import { EventPaymentList } from '../lists/eventPaymentList'
import expandableViewStyles from './styles'

const useStyles = makeStyles((theme) => ({
  ...expandableViewStyles,
  tablePanel: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
  },
  title: {
    fontSize: '18px',
    lineHeight: '21.6px',
    ...theme.mundi.font.lato700Normal,
    marginBottom: '31px',
  },
  titleTable: {
    fontSize: '18px',
    lineHeight: '21.6px',
    ...theme.mundi.font.lato700Normal,
    marginBottom: '31px',
    marginTop: '45px',
  },
  fieldName: {
    fontSize: '12px',
    lineHeight: '14.6px',
    ...theme.mundi.font.roboto400Normal,
    color: normalGray,
    marginBottom: '8px',
  },
  fieldValue: {
    fontSize: '14px',
    lineHeight: '16.41px',
    ...theme.mundi.font.roboto400Normal,
    color: darkGray,
    marginBottom: '32px',
  },
}))

export const EventsPaymentExpandableView = (props) => {
  const classes = useStyles()
  const translate = useTranslate()

  return (
    <div className={classes.panel}>
      <div className={classes.infoColumn}>
        <PaymentPayerField
          record={props.record}
          source="type"
          className={classes.title}
        />
        <Typography className={classes.fieldName}>
          {translate('resources.payments.payment.amount')}
        </Typography>
        <CurrencyField
          record={props.record}
          source={'totalEntries'}
          className={classes.fieldValue}
        />
        <Typography className={classes.fieldName}>
          {translate('resources.payments.payment.date')}
        </Typography>
        <LocalDateField
          record={props.record}
          source={'completedAt'}
          className={classes.fieldValue}
        />
        <Typography className={classes.fieldName}>
          {translate('resources.payments.payment.description')}
        </Typography>
        <PaymentDescriptionField
          record={props.record}
          source="concept"
          label={'resources.payments.payment.description'}
        />
      </div>
      <div className={classes.tablePanel}>
        <Typography className={classes.titleTable}>
          {translate('resources.payments.messages.invoiceLinkedToEntry')}
        </Typography>
        <div className={classes.tableColumn}>
          <ArrayField source="entries" {...props}>
            <EventPaymentList />
          </ArrayField>
          {/**
           * TODO
           * add: linkDataInvoices={data} when search is ready
           */}
        </div>
      </div>
    </div>
  )
}
